<template>
    <div>
        <el-card shadow="hover">
            <div slot="header" class="px-1">
                <h6 class="text-center m-0">{{ cardtitle }}</h6>
            </div>
            <BarChart  v-loading.body="false" :data="barchart" :width="500" :height="250" />
            <Loader v-if="loading.chart" />
        </el-card>
    </div>  
</template>


<script>
import Finance from '@/components/page/Finance.js'
import PieChart from '@/components/chart/Pie.js'
///import PieChart from '@/components/chart/Doughnut.js'
import BarChart from '@/components/chart/BarChart.js'
import LineChart from '@/components/chart/LineChart.js'
import { Rainbow, Rainbow3, Penanggalan, AppColors, Config, AxiosWithJar } from '@/utility.js'
import Loader from '@/components/loader/Loader2.vue'


export default {
    extends: Finance,
    components:{ 
        //PieChart,
        Loader,
        //BarChart,
        BarChart,
     },
    props: {
        title: {
            type: String,
            default: 'PIECHART',
            //required: false,
        },
        data: {
            type: Array,
            default() {
                return [];
            }
        },
        area: {
            type: String,
            default: '',
            //required: false,
        },
        year: {
            type: Number,
            default: Penanggalan().tahun,
            //required: false,
        },
        month: {
            type: Number,
            default: Penanggalan().bulan,
            //required: false,
        },
        status :{
            type: String,
            default: '',
            //required: false,
        },
        label :{
            type: String,
            default: 'Label',
            //required: false,
        },
        legend :{
            type: String,
            default: 'Legend',
            //required: false,
        },
        charttypedefault :{
            type: String,
            default: 'barchart',
            //required: false,
        },
        unitids: {
            type: Array,
            default() {
                return [];
            }
        },
        fuelcostcenters: {
            type: Array,
            default() {
                return [];
            }
        },
        showchartplunit: {
			type: Boolean,
			default: false,
		},
        loadingchart :{
            type: Boolean,
            default: false,
            //required: false,
        },
        isstacked: {
            type: Boolean,
            default: false,
        }
    },
    setup() {
        
    },
    mounted() {
        //this.setCashNonCashData()
        //this.getData()
    },
    data() {
        return {
            cardtitle: this.title, //'STATUS BY SALES AREA',
            charttype: this.charttypedefault, //'piechart',
            stacked: false,
            //chartdata: [],
            maindata: [],
            barchart: [],
            loading : {
                table: false,
                chart: this.loadingchart,
            },
            showchart: false,
        }
    }, 
    watch : {
        stacked() {
            this.setBarchart();
        },
        area(newVal, oldVal) {
            this.getData();
            //console.log('Area changed from', oldVal, 'to', newVal);
        },
        year(newVal, oldVal) {
            this.getData();
            //console.log('Year changed from', oldVal, 'to', newVal);
        },
        month(newVal, oldVal) {
            this.getData();
            //console.log('Month changed from', oldVal, 'to', newVal);
        },
        fuelcostcenters(newVal, oldVal) {
            this.getData();
            //console.log('Month changed from', oldVal, 'to', newVal);
        },
        showchartplunit(newVal, oldVal) {
            this.redrawChart();
        },
        title(newVal, oldVal) {
            this.cardtitle = newVal;
        },
        data() {
            this.setBarchart();
        },
        loadingchart(newVal, oldVal) {
            this.loading.chart = newVal;
        }
    },
    methods: {
        async getData() {
			this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/v1/plunit/barchartvolumeperproduk?'

			//this.urlRequestParams+='&date-range-start='+ (this.dateRange && this.dateRange[0] ? this.dateRange[0] : '')
			//this.urlRequestParams+='&date-range-end='+ (this.dateRange && this.dateRange[1] ? this.dateRange[1] : '')
			this.urlRequestParams+='&status='+this.status
			this.urlRequestParams+='&area='+this.area
            this.urlRequestParams+='&year='+this.year
			this.urlRequestParams+='&month='+this.month
            this.urlRequestParams+='&costcenters='+this.fuelcostcenters //all unit

			this.loading.table = true;
			this.loading.chart = true;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					//let chartdata = response.data.data.chart_data;
                    this.maindata = response.data.data.volume_per_produk.chart_data;
					//this.title = response.data.data.title.toUpperCase();
                    //this.setPiecharthData(chartdata)
                    //console.log('response ' + JSON.stringify(response.data.data.chart_data));

                    //this.cardtitle = response.data.data.volume_per_produk.title;
                    this.setBarchart();
                    this.redrawChart();
                })
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.chart = false;
					this.loading.table = false;
				})

        },

        setPiecharthData(data) {
			let item = data //CashPosition;
			//console.log('item pieChartData:' + JSON.stringify(item))
            var warna = []

            let value = [];
            let idx = 0;
            for (var row in item) {
                //add color
                warna[item[row].Label] = AppColors[idx];//'#FFB22E'

                //add value
                let main = {
                    transtype: item[row].Label, 
                    amount: item[row].Nilai,
                };

                value.push(main);
                idx++;
            }

            this.chartdata = this.processPieChart(value, "amount", "transtype", 1, 2, warna); 
        },

        setBarchart() {
            //console.log('this.data: ' + JSON.stringify(this.data))
            let label = this.label; //'Label'
            let value = 'Value'
            let legend = this.legend; //'Legend'
            this.barchart = this.processBarChart(this.data, legend, '', value, false, label, "", 1, 2, AppColors, false, false, false, this.isstacked);
        },

        redrawChart() {
            this.showchart = false
            setTimeout(() => {
                this.showchart = true
                //console.log('Redraw chart growth')
            }, 500);
        },
    }
}
</script>

<style>
.el-card__header {
    padding: 12px 10px;
}
</style>